module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "status fixed-width",
    class: "mktp_status_id_" + _vm.mktpRentStatus.mktp_status_id,
    staticStyle: {
      "margin": "-5px 0"
    }
  }, [(_vm.mktpRentStatus.mktp_status_id == 1) ? _c('div', {
    staticClass: "text"
  }, [_vm._v("Novo")]) : _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.mktpRentStatus.status.name))]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("time")(_vm.mktpRentStatus.created_at)))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fda74074!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/MktpRentStatus.vue
// module id = 1054
// module chunks = 34